/* brisk-nav.js - the desktop mega panel's and the phone drawer's behaviour.
   Moved out of snippets/main-nav-links.liquid on 2026-09-09. Both blocks were inline in the
   header, so they were re-sent and re-parsed on every navigation - 14,977 B per document, and the
   bmenu driver a second time inside the drawer's text/template blob. Measured against production
   the same day, the four launch surfaces were ADDING about 15 KB to every document; this is what
   takes that back. Same move, and the same reasoning, as the menu CSS and the fit-guide JS.

   Safe to defer: both attach DELEGATED listeners on the document, so neither needs the nav markup
   to exist when it runs, and neither is needed before the page is interactive. The capture-phase
   click listener in the bmenu driver is load-bearing - see its own comment.

   This is a plain .js asset: it must never contain a Liquid tag. Anything that needs Liquid stays
   in the snippet (the layer payload is a JSON script tag there, read at runtime by this file).
   Owner: brisk-docs/docs/shop-shirts-menu.md
*/

/* ---------- Fit Guide pill ---------- */
/* ⛔ 2026-09-11 — THE DRIVER IS GONE. It delegated clicks on [data-bnav-fitguide] and opened the
   Fit Guide drawer in place instead of navigating. The merchant asked for the mega menu's Fit
   Guide link to "take to fitguide page", and for the drawer to exist on PDPs only, so the
   attribute was removed from snippets/main-nav-links.liquid and the global drawer host was
   unrouted from layout/theme.liquid. With no element carrying the attribute this listener could
   only ever cost a closest() on every click in the document.
   Two things it knew, worth keeping if it is ever restored: stopPropagation was LOAD-BEARING
   (theme.js closes #side-drawer on any outside click, so a bubbling click opened and instantly
   re-closed it), and the 350 ms mobile timer had to be cancellable or a second tap resurrected a
   drawer the shopper had just closed. Full history: brisk-docs/docs/shop-shirts-menu.md */

/* Hover shirt preview (2026-08-20). Images preload on the FIRST mouseover of any
     mega-menu top-level item — inside theme.js's 250ms hover-intent window, so they are
     in flight before the panel is even visible. Entry hover = class toggle only. */
  (function () {
    'use strict';
    if (window.__bnavPrevReady) return; window.__bnavPrevReady = true;
    var loaded = false;
    /* 2026-09-09: the flat-shirt picker is GONE. It sampled up to four candidate images per
       row on a canvas at idle to guess which was a flat-lay, cached verdicts in sessionStorage,
       and — because its width swap never matched the minted URL — actually downloaded every
       candidate at full size on every page load. The picks are frozen in Liquid now, so the
       chosen image is already the right one and there is nothing to probe. Images still wait
       for the first hover of a top-level item, inside theme.js's 250ms hover-intent window. */
    /* 2026-09-09: the 56 hover layers are a JSON payload and one reusable slot, not 56 elements
       (see the Liquid note). Parse the payload once per panel, then a hover is: look the key up,
       write four fields, show the slot. Keys with no entry leave the rest layer up, exactly as a
       missing layer used to. */
    /* 2026-09-18: the payload moved OUT of the panel. It used to be a <script> inlined in this
       box, which put 16,056 bytes between <body> and #content on every page, ahead of the LCP
       element. It now renders once per document from layout/theme.liquid after </main>, as
       <script id="bnav-layers-shirts"> and <script id="bnav-layers-bottoms">, and the box carries
       `data-bnav-layers-ref` naming which one is its own.
       🚨 THE IN-PANEL LOOKUP IS KEPT AS A FALLBACK AND MUST STAY for now. This file is a separately
       cached asset: a browser holding the OLD brisk-nav.js against the NEW markup resolves by ref
       and is fine, but a browser holding the NEW script against markup still carrying the inline
       payload (a stale RenderBetter section cache, or a rollback of the Liquid alone) would find
       nothing. The fallback makes both orders safe. Remove it only once both sides have certainly
       rolled over.
       ⚠ Failure here is SILENT by design — a missing payload leaves the rest layer up, exactly as a
       missing layer always did. So a broken id does not throw; it just stops the hero swapping.
       Check it by hovering, not by watching the console. */
    function layerMap(box) {
      if (box.__bnavMap) return box.__bnavMap;
      var m = {}, ref = box.getAttribute('data-bnav-layers-ref'), tag = null;
      if (ref) { tag = document.getElementById(ref); }
      if (!tag) { tag = box.querySelector('script[data-bnav-layers]'); }
      if (tag) {
        try {
          JSON.parse(tag.textContent).forEach(function (r) { m[r.k] = r; });
        } catch (err) { /* a malformed payload must not take the menu down */ }
      }
      box.__bnavMap = m;
      return m;
    }
    function showLayer(box, want) {
      var rec = layerMap(box)[want];
      if (!rec) return;
      var slot = box.querySelector('[data-bnav-slot]');
      if (!slot) return;
      if (slot.__k !== want) {
        slot.__k = want;
        slot.setAttribute('href', rec.h);
        slot.setAttribute('data-bnav-preview-item', want);
        var img = slot.querySelector('img');
        if (img && img.getAttribute('src') !== rec.i) { img.setAttribute('src', rec.i); }
        var tg = slot.querySelector('.bnav-hero__tag');
        var ti = slot.querySelector('.bnav-hero__title');
        if (tg) { tg.textContent = rec.g; }
        if (ti) { ti.textContent = rec.t; }
      }
      slot.hidden = false;
      var items = box.querySelectorAll('[data-bnav-preview-item]');
      for (var i = 0; i < items.length; i++) {
        items[i].classList.toggle('is-active', items[i] === slot);
      }
    }
    /* the Shop By tablist (separate IIFE below) syncs the card to the pane's first entry */
    window.__bnavShowLayer = showLayer;
    function loadPreviews() {
      if (loaded) return; loaded = true;
      document.querySelectorAll('[data-bnav-preview] img[data-bnav-src], [data-bnav-still] img[data-bnav-src]').forEach(function (img) {
        var u = img.getAttribute('data-bnav-src');
        if (u) { img.src = u; }
        img.removeAttribute('data-bnav-src');
      });
    }
    document.addEventListener('mouseover', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!loaded && e.target.closest('.navigation__tier-1 > .navigation__item--with-mega-menu')) loadPreviews();
      var t = e.target.closest('[data-bnav-hover]');
      if (!t) return;
      var panel = t.closest('.navigation__tier-2-container');
      var box = panel && panel.querySelector('[data-bnav-preview]');
      if (!box) return;
      showLayer(box, t.getAttribute('data-bnav-hover'));
    }, { passive: true });
    /* round 3h: the wide card IS the preview now, so when the pointer leaves the panel every
       layer drops its is-active and the :first-child fallback (the Limited Drops layer) shows
       again on the next open. Without this the panel re-opened on whichever shirt was last hovered. */
    document.addEventListener('mouseout', function (e) {
      if (!e.target || !e.target.closest) return;
      var panel = e.target.closest('.navigation__tier-2-container');
      if (!panel || (e.relatedTarget && panel.contains(e.relatedTarget))) return;
      var on = panel.querySelectorAll('[data-bnav-preview] [data-bnav-preview-item].is-active');
      for (var i = 0; i < on.length; i++) on[i].classList.remove('is-active');
    }, { passive: true });
  })();

  /* SHOP BY tabs (desktop round 2, merchant 2026-09-04). Hovering or focusing a row in the
     SHOP BY column swaps the pane beside it. Everything is already in the DOM — this only
     moves classes, so there is no fetch, no layout jump and nothing to preload.
     Written here rather than in theme.js: assets/theme.js is do-not-touch (dossier section 3),
     and this mirrors __bnavPrevReady's shape (one delegated listener, idempotent guard). */
  (function () {
    'use strict';
    if (window.__bnavShopByReady) return; window.__bnavShopByReady = true;
    var HOVER_MS = 110; /* pointer travelling diagonally to the panes must not strobe the
                           groups it crosses. theme.js's own 250ms is tier-1 switching, a
                           different mechanism, and stays as it is. */
    var timer = null;

    function activate(tab) {
      var col = tab.closest('.bnav-sb');
      var panel = tab.closest('.navigation__tier-2-container');
      if (!col || !panel) return;
      var panes = panel.querySelector('.bnav-sb__panes');
      if (!panes) return;
      var want = tab.getAttribute('data-bnav-shopby');
      var tabs = col.querySelectorAll('[data-bnav-shopby]');
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i] === tab;
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].setAttribute('tabindex', on ? '0' : '-1');
        tabs[i].classList.toggle('is-active', on);
      }
      var list = panes.querySelectorAll('[data-bnav-shopby-pane]');
      for (var j = 0; j < list.length; j++) {
        list[j].classList.toggle('is-active', list[j].getAttribute('data-bnav-shopby-pane') === want);
      }
      /* keep the shirt photo agreeing with the pane: show this group's first entry card.
         The keys already exist (group--entry); if the group has none, the photo is left alone. */
      var box = panel.querySelector('[data-bnav-preview]');
      var lead = panes.querySelector('.bnav-sb__pane.is-active [data-bnav-hover]');
      if (box && lead && window.__bnavShowLayer) {
        window.__bnavShowLayer(box, lead.getAttribute('data-bnav-hover'));
      }
    }

    document.addEventListener('mouseover', function (e) {
      if (!e.target || !e.target.closest) return;
      var t = e.target.closest('[data-bnav-shopby]');
      if (!t || t.getAttribute('aria-selected') === 'true') return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { activate(t); }, HOVER_MS);
    }, { passive: true });

    document.addEventListener('mouseout', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-bnav-shopby]') && timer) { clearTimeout(timer); timer = null; }
    }, { passive: true });

    /* keyboard + coarse pointers: immediate, no hover-intent */
    document.addEventListener('focusin', function (e) {
      if (!e.target || !e.target.closest) return;
      var t = e.target.closest('[data-bnav-shopby]');
      if (t) { if (timer) clearTimeout(timer); activate(t); }
    });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var t = e.target.closest('[data-bnav-shopby]');
      if (!t) return;
      e.preventDefault();
      if (timer) clearTimeout(timer);
      activate(t);
    });

    /* WAI-ARIA tabs, automatic activation: focus follows the arrow key and the pane follows focus */
    document.addEventListener('keydown', function (e) {
      if (!e.target || !e.target.closest) return;
      var t = e.target.closest('[data-bnav-shopby]');
      if (!t) return;
      var col = t.closest('.bnav-sb');
      if (!col) return;
      var tabs = Array.prototype.slice.call(col.querySelectorAll('[data-bnav-shopby]'));
      var i = tabs.indexOf(t), n = -1;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = tabs.length - 1;
      if (n < 0) return;
      e.preventDefault();
      tabs[n].focus();
      /* activate explicitly rather than leaning on the focusin handler: a programmatic focus()
         does not dispatch focus events when the document itself is not focused, so the pane
         would silently lag behind the arrow keys. focusin still covers Tab-key entry. */
      if (timer) clearTimeout(timer);
      activate(tabs[n]);
    });
  })();

/* ---------- bmenu driver (phone drawer accordions) ---------- */
(function () {
    if (window.__bmenuReady) return;
    window.__bmenuReady = true;
    var pendingOpen = false;
    document.addEventListener('click', function (e) {
      var body = document.body;
      /* 2026-09-09 QA: this listener is CAPTURE-phase on document, so an unguarded closest() on a
         non-Element target (a synthetic click from a third-party script) would throw here and kill
         every click handler on the page, add-to-cart included. */
      if (!e.target || !e.target.closest) return;
      var closeCtl = e.target.closest('.mobile-nav-toggle, .header-shade, .page-shade');
      if (closeCtl) {
        var engaged = body.classList.contains('enable-mobile-nav-transition');
        var revealed = body.classList.contains('reveal-mobile-nav');
        /* a tap meant to OPEN while the teardown is still running: the theme reads it as a
           close, so replay it through the stock open path once the teardown state clears */
        if (engaged && !revealed && !pendingOpen && !closeCtl.closest('.mobile-navigation-drawer')
            && window.theme && theme.openMobileNav) {
          /* swallow the tap so the theme's own handler cannot schedule a second
             enable-strip (that stray strip landed mid-open and inverted the toggle) */
          e.preventDefault();
          e.stopPropagation();
          pendingOpen = true;
          var tries = 0;
          var iv = setInterval(function () {
            tries++;
            if (body.classList.contains('reveal-mobile-nav')) { clearInterval(iv); pendingOpen = false; return; }
            if (!body.classList.contains('enable-mobile-nav-transition')) {
              clearInterval(iv); pendingOpen = false; theme.openMobileNav(); return;
            }
            if (tries > 20) { clearInterval(iv); pendingOpen = false; }
          }, 60);
          return;
        }
        /* a real close: reset every open fold once the drawer is off-screen, so each open
           starts fresh and the entrance stagger replays over a closed menu */
        setTimeout(function () {
          if (body.classList.contains('reveal-mobile-nav')) return;
          document.querySelectorAll('.mobile-navigation-drawer .is-open').forEach(function (el) {
            el.classList.remove('is-open');
          });
          document.querySelectorAll('.mobile-navigation-drawer [aria-expanded="true"]').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
          });
        }, 400);
        return;
      }
      var t = e.target.closest('.bmenu-toggle, button.bmenu-grouplab, button.bmenu-link--root');
      if (!t || !t.closest('.mobile-navigation-drawer')) return;
      e.preventDefault();
      var item = t.closest('.bmenu-item, .bmenu-subitem');
      if (!item) return;
      var open = item.classList.toggle('is-open');
      var row = item.querySelector(':scope > .bmenu-row');
      if (row) {
        /* button.bmenu-link--root is in this list because a root item with children and no real
           URL renders its LABEL as the toggle ("Help & Info"). It was missing here, so that fold
           opened while its button kept aria-expanded="false" - measured 2026-09-09. */
        row.querySelectorAll('.bmenu-toggle, button.bmenu-grouplab, button.bmenu-link--root').forEach(function (b) {
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
    }, true);
  })();

  /* 2026-09-09: the announcement bar's Swiper keeps looping behind the open drawer. Profiled on a
     390px viewport at 6x CPU throttle: slideNext and its in-view maths were live main-thread work
     while the drawer covered the screen, on a carousel nobody can see. Pause its autoplay while the
     drawer is open and start it again on close. window.swiper is the init in sections/header.liquid;
     everything here is null-guarded, so if the bar is switched off this is inert. The observer is
     change-only (invariant #7) and never writes to the attribute it watches. */
  (function () {
    'use strict';
    if (window.__bmenuAbPause) return; window.__bmenuAbPause = true;
    var wasOpen = false;
    function sync() {
      var open = document.body.classList.contains('reveal-mobile-nav');
      if (open === wasOpen) return;
      wasOpen = open;
      var sw = window.swiper;
      if (!sw || !sw.autoplay) return;
      try { if (open) { sw.autoplay.stop(); } else { sw.autoplay.start(); } } catch (e) {}
    }
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  })();
